import styled from 'styled-components/macro';
import { FlexJustifyBetween } from '../../../../shared-styles/flex';

export const Header = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.small};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  color: ${({ theme }) => theme.palette.black[50]};
  margin-bottom: ${(props) => props.theme.spacing(10)};
`;

export const HeaderContainer = styled.div`
  ${FlexJustifyBetween}
`;

export const CardContainer = styled.div`
  max-width: 100%;
  flex-wrap: wrap;
  background-color: ${(props) => props.theme.palette.custom.lightRed};
  border: 0.5px solid ${(props) => props.theme.palette.red[100]};  
  border-radius: 10px;
  padding: ${(props) => props.theme.spacing(15)} ${(props) => props.theme.spacing(20)};
  `;

export const LoadProblem = styled.span`
  display:inline-flex;    
  background-color: ${(props) => props.theme.palette.red[100]};
  font-size: ${({ theme }) => theme.typography.sizes.small};
  color: ${(props) => props.theme.palette.white};
  border-radius: 10px;
  margin: 0px ${(props) => props.theme.spacing(10)} ${(props) => props.theme.spacing(5)} 0px;
  padding: ${(props) => props.theme.spacing(5)} ${(props) => props.theme.spacing(12)}; 
`;
